"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerTabSet = exports.BmTabSet = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _bmTabItem = require("./bm-tab-item");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<slot></slot>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: flex;\n\t\tcontain: content;\n\t}\n\n\t:host([placement='top']) {\n\t\tborder-bottom: 3px solid #37383d;\n\t\tflex-direction: row;\n\t\tjustify-content: flex-start;\n\t}\n\n\t:host([placement='right']) {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tdisplay: inline-flex;\n\t\tborder-left: 3px solid #37383d;\n\t}\n\n\t:host([placement='bottom']) {\n\t\tborder-top: 3px solid #37383d;\n\t\tflex-direction: row;\n\t\tjustify-content: flex-start;\n\t}\n\n\t:host([placement='left']) {\n\t\tborder-right: 3px solid #37383d;\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t\tdisplay: inline-flex;\n\t}\n\n\t:host([placement='right']) ::slotted(bm-tab-item),\n\t:host([placement='left']) ::slotted(bm-tab-item) {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t:host([placement='right']) ::slotted(bm-tab-item:last-child),\n\t:host([placement='left']) ::slotted(bm-tab-item:last-child) {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:host([placement='top']) ::slotted(bm-tab-item),\n\t:host([placement='bottom']) ::slotted(bm-tab-item) {\n\t\tmargin-right: 5px;\n\t}\n\n\t:host([placement='top']) ::slotted(bm-tab-item:last-child),\n\t:host([placement='bottom']) ::slotted(bm-tab-item:last-child):last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t:host([placement='top']) ::slotted(bm-tab-item) {\n\t\tborder-radius: 5px 5px 0 0;\n\t\tborder-bottom: 0;\n\t}\n\n\t:host([placement='right']) ::slotted(bm-tab-item) {\n\t\tborder-radius: 0 5px 5px 0;\n\t\tborder-left: 0;\n\t}\n\n\t:host([placement='bottom']) ::slotted(bm-tab-item) {\n\t\tborder-radius: 0 0 5px 5px;\n\t\tborder-top: 0;\n\t}\n\n\t:host([placement='left']) ::slotted(bm-tab-item) {\n\t\tborder-radius: 5px 0 0 5px;\n\t\tborder-right: 0;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmTabSet = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmTabSet, _BlueElement);

  var _super = (0, _createSuper2.default)(BmTabSet);

  (0, _createClass2.default)(BmTabSet, [{
    key: "root",
    get: function get() {
      var _this$shadowRoot;

      return (_this$shadowRoot = this.shadowRoot) !== null && _this$shadowRoot !== void 0 ? _this$shadowRoot : this;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-tab-set';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        current: {
          type: Object,
          attribute: false,
          reflect: false
        },
        placement: {
          type: String,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmTabSet() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmTabSet);
    _this = _super.call(this);
    _this.placement = 'top';
    _this.onSlotChange = (0, _bind.default)(_context = _this.onSlotChange).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmTabSet, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var slot;
        return _regenerator.default.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                (0, _get2.default)((0, _getPrototypeOf2.default)(BmTabSet.prototype), "connectedCallback", this).call(this);
                this.addEventListener('click', this.onClick);
                _context2.next = 4;
                return this.updateComplete;

              case 4:
                slot = this.root.querySelector('slot');

                if (slot) {
                  slot.removeEventListener('slotchange', this.onSlotChange);
                  slot.addEventListener('slotchange', this.onSlotChange);
                  this.onSlotChange();
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "onSlotChange",
    value: function onSlotChange() {
      var _context3, _context4;

      var slot = this.root.querySelector('slot');

      if (!slot) {
        return;
      }

      this.items = (0, _filter.default)(_context3 = slot.assignedNodes()).call(_context3, function (element) {
        return element.nodeName === 'BM-TAB-ITEM';
      });

      if (!this.current || !(0, _includes.default)(_context4 = this.items).call(_context4, this.current)) {
        var _this$items$find, _context5;

        var newCurrent = (_this$items$find = (0, _find.default)(_context5 = this.items).call(_context5, function (element) {
          return element.active;
        })) !== null && _this$items$find !== void 0 ? _this$items$find : this.items[0];
        this.changeCurrent(newCurrent);
      }
    }
  }, {
    key: "findTabElement",
    value: function findTabElement(el) {
      if (el.tagName === _bmTabItem.BmTabItem.is.toUpperCase()) {
        return el;
      }

      if (el.parentElement) {
        return this.findTabElement(el.parentElement);
      }

      return undefined;
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (event.target && event.target !== this) {
        var tab = this.findTabElement(event.target);

        if (tab) {
          this.changeCurrent(tab);
        }
      }
    }
  }, {
    key: "changeCurrent",
    value: function changeCurrent(item) {
      var _context6;

      (0, _forEach.default)(_context6 = this.items).call(_context6, function (i) {
        i.active = false;
      });
      item.active = true;
      this.current = item;
      this.dispatchEvent(new CustomEvent('change', {
        detail: this.current.name
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }]);
  return BmTabSet;
}(_element.BlueElement);

exports.BmTabSet = BmTabSet;

var registerTabSet = function registerTabSet() {
  (0, _bmTabItem.registerTabItem)();
  (0, _element.register)(BmTabSet);
};

exports.registerTabSet = registerTabSet;
